/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconClip.vue?vue&type=template&id=76006cff&scoped=true"
import script from "./IconClip.vue?vue&type=script&lang=js"
export * from "./IconClip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76006cff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76006cff')) {
      api.createRecord('76006cff', component.options)
    } else {
      api.reload('76006cff', component.options)
    }
    module.hot.accept("./IconClip.vue?vue&type=template&id=76006cff&scoped=true", function () {
      api.rerender('76006cff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconClip.vue"
export default component.exports